<div class="view-component">
    <div class="view-component-title">
        <span class="title">Dicionário de Dados</span>
    </div>
    <div class="content">
        <simple-datagrid entityName="Mktpdic" [parentRow]="parentRow" [condition]="condition" nodata="true" [events]="eventsSubject.asObservable()"></simple-datagrid>
    </div>
</div> 